import { trackEvent, updateUserContext } from "@utils/api/tracker";
import { captureException } from "src/utils/error";
import { ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";
import { isEligibleForTelehealthReimbursement } from "src/utils/userSegment/features";
import { getCurrentSurveyAnswers, resetCurrentSurvey } from "src/hooks/survey";
import { clearCheckoutTimerExpirationCookie } from "src/utils/checkoutTimer";
import saveToBraze from "@utils/brazeUploader";
import { getRouteId } from "@utils/meristemContext";
import { saveAnswers } from "./saveAnswers";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompletePaymentSurvey = async (
  actionParams: {
    params?: Params;
  } & ActionHandlerParams
) => {
  const { params = {}, store, pageSet, page } = actionParams;
  const survey = getPageSetSurvey(pageSet, page);
  const finishedEvent = params.finishedEvent || `Finished${survey.name}`;

  const currentAnswers = getCurrentSurveyAnswers();
  const { userData } = store.getState();

  try {
    // Clear the checkout timer when we attempt to save answers to the database
    await clearCheckoutTimerExpirationCookie();
    await saveAnswers({
      ...actionParams,
      params: { completeDateField: "purchaseSurveyCompleteDateISO" },
    });

    resetCurrentSurvey();

    updateUserContext({
      telehealthEligible: isEligibleForTelehealthReimbursement(),
    });

    saveToBraze(userData.user_id, null, {
      event_name: "finished_payment_survey",
      event_data: { routeId: getRouteId(), ...currentAnswers },
    });

    trackEvent(finishedEvent, currentAnswers);
  } catch (e) {
    // TODO: Tag and throw or log and throw?
    captureException(e, "onCompletePurchaseSurvey");
    throw e;
  }
};
